module.exports = "<div class=\"aside\" id=\"installmentOptions\" xo-tray-height>\n    <xo-aside-header close-url=\"{{backUri}}\" heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <div class=\"installmentOptions asideContent container\">\n       <xo-installment-options token=\"token\" done-fn=\"onComplete\" card-number=\"cardInfo.number\"></xo-installment-options>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./pages/xo-sidebar-installment-options/template.html
// module id = ../node_modules/noop-loader/index.js!./pages/xo-sidebar-installment-options/template.html
// module chunks = 1